<template>
  <div
    v-if="data"
    class="usdt_wrap"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ data.payment.name }}
      </div>
      <button
        type="button"
        class="customer-service-btn"
        @click="$router.push('/kefu')"
      >
        <img
          src="../images/shop2/kefu.jpg"
          :alt="$t('user.help')"
        >
      </button>
    </div>
    <div class="code_box">
      <div class="money">
        <span style="font-size: 14px;">{{ data.payment.mark }}</span>
        {{ money }}
      </div>
			
      <div class="qrcode_img">
        <img
          class="qrcode"
          :src="data.pay_image"
          alt=""
        >
      </div>
      <div
        v-if="data.payment.type==1"
        class="wallet"
      >
        {{ $t('invest_qrcode.walletAddress') }}
      </div>
      <div
        v-if="data.payment.type==1"
        class="walletAddress"
        @click="copyAddress"
      >
        {{ data.addr }}
      </div>
      <div v-if="data.payment.type==1">
        {{ $t('invest_qrcode.scanQRcode') }}
      </div>
    </div>
    <div
      v-if="data.payment.type==1"
      class="button_box"
    >
      <div
        class="copy_link"
        @click="copyAddress"
      >
        {{ $t('invest_qrcode.copyWalletAddress') }}
      </div>
    </div>
    <div
      class="submit-btn"
      @click="submitBtn"
    >
      {{ $t('utils.submit') }}
    </div>
  </div>
</template>

<script>
    import Fetch from '../../utils/fetch'
    export default {
        name: "InvestQrcode",
        data() {
            return {
                data: null,
                money: 0,
				actualAmount:'',
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.money = this.$route.query.money;
            this.start();
        },
        methods: {
            start() {
            	Fetch('/user/recharge_type', {
            		money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : "",
					type:this.$route.query.type ? this.$route.query.type : "1",
					reason:this.$route.query.reason ? this.$route.query.reason : ""
            	}).then((r) => {
            		this.data = r.data;
					this.changeAmount();
            	});
            },
            submitBtn(){
				Fetch("/user/recharge_apply", {
					id: this.data.orderId
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				});
			},
			copyAddress() {
				var address = this.data && this.data.addr ? String(this.data.addr).trim() : '';
				if (!address) {
					this.copyFailed();
					return;
				}
				if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(address).then(() => {
						this.copy();
					}).catch(() => {
						if (this.copyTextBySelection(address)) {
							this.copy();
						} else {
							this.copyFailed();
						}
					});
					return;
				}
				if (this.copyTextBySelection(address)) {
					this.copy();
				} else {
					this.copyFailed();
				}
			},
			copyTextBySelection(text) {
				var input = document.createElement('textarea');
				input.value = text;
				input.setAttribute('readonly', 'readonly');
				input.style.position = 'fixed';
				input.style.left = '-9999px';
				input.style.top = '0';
				input.style.opacity = '0';
				document.body.appendChild(input);
				input.focus();
				input.select();
				input.setSelectionRange(0, input.value.length);
				var copied = false;
				try {
					copied = document.execCommand('copy');
				} catch (e) {
					copied = false;
				}
				document.body.removeChild(input);
				return copied;
			},
			copy() {
			    this.$toast({
			        background: '#07c160',
			        message: this.$t('invest_qrcode.copySucceeded')
			    })
			},
			copyFailed() {
				this.$toast(this.$t('invest_qrcode.copyFailed'));
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + this.utils_moneyMark() + (Number(this.money) * Number(this.data.payment.rate)).toFixed(2) + ")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num)+")";
				}
			}
        }
    };
</script>

<style lang="less" scoped>
.usdt_wrap {
  --accent: #f3c99e;
  --text: #eab98d;
  --muted: #b28d6c;
  --line: #75654f;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow-y: auto;
  padding-bottom: calc(28px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  background: #201c1d;
  color: var(--text);
  -webkit-overflow-scrolling: touch;
}
.red_top_bg {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 54px;
  border-bottom: 1px solid #302723;
  box-sizing: border-box;
  background: #201c1d;
  color: var(--accent);

  .big_tit {
    position: static;
    width: 100%;
    margin: 0;
    padding: 0;
    color: var(--accent);
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .back_left {
    position: absolute;
    top: 5px;
    left: 4px;
    width: 40px;
    height: 40px;
    margin: 0;
    background: none;
    cursor: pointer;

    &::before {
      position: absolute;
      top: 14px;
      left: 15px;
      width: 9px;
      height: 9px;
      border-left: 2px solid var(--accent);
      border-bottom: 2px solid var(--accent);
      transform: rotate(45deg);
      content: '';
    }
  }
  .customer-service-btn {
    position: absolute;
    top: 9px;
    right: 12px;
    width: 32px;
    height: 32px;
    padding: 2px;
    border: 1px solid var(--line);
    border-radius: 50%;
    background: #302c29;
    line-height: 0;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}
.code_box {
  width: calc(100% - 28px);
  margin: 22px auto 0;
  padding: 26px 18px 22px;
  border: 1px solid var(--line);
  border-radius: 12px;
  box-sizing: border-box;
  background: linear-gradient(110deg, #232323, #303030);
  box-shadow: 0 8px 24px rgba(0, 0, 0, .18);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 12px;
  line-height: 20px;

  .money {
    max-width: 100%;
    margin-bottom: 22px;
    color: var(--accent);
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    overflow-wrap: anywhere;
  }
  .qrcode_img {
    width: 220px;
    max-width: 100%;
    padding: 14px;
    border: 1px solid #f3c99e;
    border-radius: 10px;
    box-sizing: border-box;
    background: #fff;
    line-height: 0;

    img {
      display: block;
      width: 100%;
      height: auto;
      margin: 0;
    }
  }
  .wallet {
    margin-top: 22px;
    color: var(--muted);
    font-size: 12px;
  }
  .walletAddress {
    width: 100%;
    margin: 10px 0 14px;
    padding: 12px;
    border: 1px solid var(--line);
    border-radius: 8px;
    box-sizing: border-box;
    background: #201c1d;
    color: var(--accent);
    font-size: 12px;
    line-height: 20px;
    overflow-wrap: anywhere;
    word-break: break-all;
    cursor: pointer;
  }
}
.button_box {
  width: calc(100% - 28px);
  margin: 14px auto 0;

  .copy_link {
    min-height: 44px;
    padding: 12px 16px;
    border: 1px solid var(--line);
    border-radius: 9px;
    box-sizing: border-box;
    background: linear-gradient(110deg, #232323, #303030);
    color: var(--accent);
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    overflow-wrap: anywhere;
    cursor: pointer;

    &:active { background: #3a332c; }
  }
}
.submit-btn {
  width: calc(100% - 28px);
  min-height: 44px;
  margin: 18px auto 0;
  padding: 12px 16px;
  border: 1px solid var(--line);
  border-radius: 9px;
  box-sizing: border-box;
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
  color: #5a4839;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  overflow-wrap: anywhere;
  cursor: pointer;

  &:active { filter: brightness(.94); }
}
</style>
